"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedwalletempty = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedwalletempty` : '') + (description ? ` desc-brandedwalletempty` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedwalletempty"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedwalletempty"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#f26b1c",
    d: "M62 43.25A3.75 3.75 0 0 1 58.25 47H5.75A3.75 3.75 0 0 1 2 43.25V5.75A3.75 3.75 0 0 1 5.75 2h52.5A3.75 3.75 0 0 1 62 5.75z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#cc0058",
    d: "M2.78 5.85c0-1.48 1.2-2.68 2.68-2.68h52.46c1.48 0 2.68 1.2 2.68 2.68v8.65H2.78z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#ffc599",
    fillOpacity: ".5",
    d: "M32.47 15.28h28.14v.79H32.47z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    fillOpacity: ".12",
    d: "M32.47 14.5h28.14v.78H32.47z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#f8985a",
    d: "M39.5 19.54a3.75 3.75 0 0 0-2.36-3.48L4.57 3.03A1.88 1.88 0 0 0 2 4.77v39.7a3.75 3.75 0 0 0 2.36 3.47l30 13.8a3.75 3.75 0 0 0 5.14-3.49z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#f26b1c",
    d: "M20.75 47.94a.94.94 0 0 1 1.23-.9l9.38 3.71a.9.9 0 0 1 .64.89v1.92a.94.94 0 0 1-1.23.9l-9.38-3.71a.9.9 0 0 1-.64-.89z"
  }));
};
var _default = exports.default = brandedwalletempty;